import { COOKIE_DOMAIN } from "@/config"

const PATH = "/"
const SAME_SITE = "Lax"

function attributes(): string {
  let attrs = `Path=${PATH}; SameSite=${SAME_SITE}`
  if (COOKIE_DOMAIN) attrs += `; Domain=${COOKIE_DOMAIN}`
  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    attrs += "; Secure"
  }
  return attrs
}

/**
 * Set a session cookie (no Max-Age/Expires => removed when the browser session ends).
 * Readable across subdomains when VITE_COOKIE_DOMAIN is configured (e.g. .algobuilder.com).
 */
export function setSessionCookie(name: string, value: string): void {
  try {
    document.cookie = `${name}=${encodeURIComponent(value)}; ${attributes()}`
  } catch {
    /* ignore */
  }
}

export function getCookie(name: string): string | null {
  try {
    const prefix = `${name}=`
    const match = document.cookie
      .split("; ")
      .find((row) => row.startsWith(prefix))
    return match ? decodeURIComponent(match.slice(prefix.length)) : null
  } catch {
    return null
  }
}

export function deleteCookie(name: string): void {
  try {
    document.cookie = `${name}=; Max-Age=0; ${attributes()}`
  } catch {
    /* ignore */
  }
}

// Bot draft (new-strategy prompt) — single source of truth for the cookie name.
export const BOT_DRAFT_COOKIE = "ab_prompt"
export const getBotDraft = (): string => getCookie(BOT_DRAFT_COOKIE) ?? ""
export const saveBotDraft = (value: string): void =>
  setSessionCookie(BOT_DRAFT_COOKIE, value)
export const clearBotDraft = (): void => deleteCookie(BOT_DRAFT_COOKIE)
